<template>
    <div class="settings_right filingfee_list">
        <div class="content-header filingfee-header " >
            <div class="content-header-left">
                <div class="con-select filingFee_select">
                    <label class="form-label">Case Type</label>
                    <multiselect @input="getFillingContent" v-model="selectedCaseType" :options="visaTypes" :multiple="false"
                        :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Case Type" label="name"
                        track-by="name" :preselect-first="false" :allow-empty="false">

                        <template slot="selection" slot-scope="{ values, isOpen }">
                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case Type(s)
                            Selected</span>
                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="header-actions">
                <button class="IB_primary-btn" :disabled="submitingFilingFee" @click="saveInvoice">
                    <template v-if="alreadyExisted"> Update</template>
                    <template v-else> Save</template>
                </button>
                <!-- <vs-button   :disabled="submitingFilingFee" @click="saveInvoice" class="IB_primary-btn" type="filled" >
                    <template v-if="alreadyExisted"> Update</template>
                    <template v-else> Save</template>
                </vs-button> -->
            </div>
        </div>
        <div class="badboard_skelton_sec">
            <NoDataFound ref="NoDataFoundRef" :loading="isListloading" v-if="feeData.length == 0" content=""
            :heading=" 'No Results Found'" type='petitions' />
        </div>
        <template v-if="feeData.length > 0" >
            <form  data-vv-scope="filingFeesform" @submit.prevent> 
                <div class="list-items-wrap "> 
                    <div class="subtypes_list">
                        <ul>
                            <li v-for="(item, index) in all_subtypes" :key="index">
                            <a :class="{ activetype:checkProperty(activeTab, 'id') == checkProperty(item, 'id') }"  @click="setActive(item)"><span>{{ item['name'] }}</span></a>
                            </li>
                        </ul>
                    </div>
                    <div class="list-items-cnt">
                        <div class="list-items-in">
                            <template  v-for="(filingObj ,index) in feeData">
                                <div class="list-items" v-show="checkProperty(filingObj, 'id') == checkProperty(activeTab, 'id')"> 
                                    <!-- <h3 class="small-header">{{checkProperty(filingObj, 'name')}}</h3> isAlreadyExisted -->
                                                
                                    <template v-if="checkProperty(filingObj, 'details') && checkProperty(filingObj, 'details' ,'length')>0">
                                            <div class="list-item"  :key="inde" v-for="(filingFee ,inde) in filingObj['details']" > 
                                                <div class="list-item-cnt">
                                                    <div class="list-title" >
                                                        <label class="title" v-if="checkProperty(filingFee, 'name')  && !checkProperty(filingFee, 'isEdit')">
                                                            {{checkProperty(filingFee, 'name')}} 
                                                            <span v-if="checkProperty(filingFee, 'online')" class="online_label">Online</span>
                                                            <span class="edit" @click="filingFee['isEdit'] = !filingFee['isEdit'];updateFeeDate()">
                                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
                                                                    <defs>
                                                                    <clipPath id="clip-path">
                                                                        <rect id="Rectangle_24985" data-name="Rectangle 24985" width="20" height="20" transform="translate(1104 600)" fill="#fff" stroke="#707070" stroke-width="1"/>
                                                                    </clipPath>
                                                                    </defs>
                                                                    <g id="Mask_Group_79475" data-name="Mask Group 79475" transform="translate(-1104 -600)" clip-path="url(#clip-path)">
                                                                    <path id="edit" d="M14,2.189A2.192,2.192,0,0,0,10.256.642L1.43,9.5A2.626,2.626,0,0,0,.8,10.529l-.008.024L0,14.024l3.478-.778.022-.009A2.631,2.631,0,0,0,4.528,12.6l8.827-8.867A2.178,2.178,0,0,0,14,2.189ZM1.928,12.47,1.56,12.1l.266-1.167L3.1,12.207Zm10.655-9.5-8.569,8.6L2.463,10.017l5.87-5.893.894.894L10,4.243l-.9-.895.833-.836.9.9.775-.775-.9-.9.321-.322A1.1,1.1,0,1,1,12.58,2.966ZM5.759,12.916H14v1.094H4.667Zm0,0" transform="translate(1107 603.002)" fill="#0E1D48"/>
                                                                    </g>
                                                                </svg>                                                              
                                                            </span>
                                                        </label>
                                                        <template v-else>
                                                            <!-- @input="updateFeeName(filingObj['details'][inde], index)"  -->
                                                            <div class="editmode">
                                                                <vs-input data-vv-as="Fee Type" v-validate="'required'" :name="'feeType'+inde"
                                                                
                                                                    v-model="filingObj['details'][inde]['editVal']" class="amount_input"  /> 
                                                                    <span  class="save" @click="filingFee['name'] = filingFee['editVal'];filingFee['isEdit'] = !filingFee['isEdit'];updateFeeDate();updateFeeName(filingObj['details'][inde], index)">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="16.001" viewBox="0 0 16.001 16.001">
                                                                            <g id="check" opacity="0.8">
                                                                                <g id="Group_8119" data-name="Group 8119">
                                                                                <path id="Path_34467" data-name="Path 34467" d="M8,0a8,8,0,1,0,8,8A8.032,8.032,0,0,0,8,0ZM7.032,11.64l-3.5-3.5L4.855,6.81,7.094,9.05l4.5-4.086L12.851,6.35Z" fill="#27a438"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>                                                          
                                                                    </span>
                                                                </div>
                                                            <span class="text-danger text-sm" v-show="errors.has('filingFeesform.feeType'+inde)">{{ errors.first('filingFeesform.feeType'+inde) }}</span>
                                                        </template>
                                                    </div>
                                                    <div class="amount" >
                                                        <vs-input
                                                            data-vv-as="Amount"
                                                            v-validate="''"
                                                            v-model="filingFee.amount"
                                                            :name="'amountUSCIS'+index+inde"
                                                            v-mask="'######'"
                                                            class="amount_input input_prefix"
                                                        /> 
                                                        <!-- <span
                                                            class="text-danger text-sm"
                                                            v-show="errors.has('filingFeesform.amountUSCIS'+index+inde)"
                                                            >{{ errors.first('filingFeesform.amountUSCIS'+index+inde) }}
                                                        </span> -->
                                                        <div class="list-actions">
                                                            <ul>
                                                                <li v-if="false">
                                                                    <span>
                                                                        <svg width="20" height="20" viewBox="0 0 12 12">
                                                                            <path id="Path_626" data-name="Path 626" d="M6,0a6,6,0,1,0,6,6A6.023,6.023,0,0,0,6,0ZM5.274,8.729,2.646,6.1l.994-.994L5.32,6.787,8.691,3.722l.946,1.04Z" fill="#97d856"/>
                                                                        </svg>                                                          
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <svg class="bin" v-if="!checkProperty(filingFee, 'defType')"  @click="removeItem(index, inde)" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg>
                                                                    </span>
                                                                </li>
                                                            </ul> 
                                                        </div>
                                                    </div> 
                                                </div>
                                                
                                                <div class="radio_sec" :class="{'mart10':checkProperty(filingFee, 'isEdit') || !checkProperty(filingFee, 'name')}" v-if="checkProperty(filingFee, 'code') == 'DEPENDENTLEGAL'">
                                                    <vs-radio v-model="filingObj['details'][inde]['perOrAllDependent']" :vs-name="'perOrAllDependent'+inde+index" :vs-value="false">Per dependent</vs-radio>
                                                    <vs-radio v-model="filingObj['details'][inde]['perOrAllDependent']" :vs-name="'perOrAllDependent'+inde+index" :vs-value="true">All dependents together</vs-radio>
                                                </div>     
                                                <small v-if="['H4I539ONLINE', 'H4I539', 'L2I539','L2I539ONLINE'].indexOf(checkProperty(filingFee, 'code'))>-1" class="reff_text" :class="{'mart12':checkProperty(filingFee, 'isEdit') || !checkProperty(filingFee, 'name')}" >(Dependents)</small>                                           
                                               <template v-if="checkProperty(filingFee, 'type') != 'USCIS' && checkProperty(filingFee, 'name') ">
                                                <vs-checkbox  :name="filingFee['name'] + inde"  v-model="filingFee.allowMultiple"  class="req_docs_sub pt-3 pl-0 ml-0 checkboxV2" :class="{'mart-10':!checkProperty(filingFee, 'isEdit')}" >
                                                    Multiple 
                                                </vs-checkbox>
                                               </template>
                                            </div> 

                                        <!-- </template> -->
                                    </template>
                                </div>
                                <div class="list-items-footer" v-show="checkProperty(filingObj, 'id') == checkProperty(activeTab, 'id')">
                                    <button class="IB_text-link" @click="addItem(index)">
                                        + Add More
                                    </button>
                                </div>
                            </template> 
                            <span v-if="checkLoading" class="loader"><img src="@/assets/images/main/loader.gif"></span>
                        </div>
                    </div>
                </div>       
                
                        
                     
                    
                
                    
                 
                <!-- <div class="popup-footer filingfee_footer" >
                <span class="loader" v-if="submitingFilingFee" ><img src="@/assets/images/main/loader.gif"/></span>
                <div class="footer-cnt">
                    <vs-button  color="success" :disabled="submitingFilingFee" @click="saveInvoice" class="save" type="filled" >
                        <template v-if="alreadyExisted"> Update</template>
                        <template v-else> Save</template>
                    </vs-button>
                </div>
                
            </div> -->
            </form>
        </template>


        <vs-popup class="holamundo main-popup cls-btn" :title="'Invoice'" :active.sync="showConfirmPopup">
            <div class="form-container">
                <div class="vx-row">
                    <datepickerField  :display="true"  :wrapclass="'md:w-full'"  :validationRequired="false" v-model="invoiceDate"
                    :fieldName="'invoiceDate'" label="Date" />
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="showConfirmPopup = false;invoiceDate=null">No</vs-button>
                <vs-button @click="manageInvoice();showConfirmPopup = false" class="save questionnaire_btn" type="filled">Yes </vs-button>
            </div>
        </vs-popup>
     
      
    </div>
  </template>
  
  <script> 
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import NoDataFound from "@/views/common/noData.vue";
  import * as _ from "lodash";
  export default {
    provide() {
      return {
          parentValidator: this.$validator,
      };
    },
    computed: {
       acceptedFiles(){
        let returnValue ='*';
       
            returnValue ='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          
  
       
        return returnValue;
        //image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document
      }
      
    },
    components: {
        selectField,
        datepickerField,
        NoDataFound,
        immiInput
    },
  
    data: () => ({
        checkLoading:false,
        masterFeeData:[],
        filingFeeName:null,
        alreadyExisted:false,
        isListloading: false,
        showConfirmPopup:false,
        invoiceDate:null,
        selectedCaseType:null,
        visaTypes:[],
        all_subtypes:[],
        submitingFilingFee:false,
        feeDa:[
    {
        "amount": "460",
        "description": "I-129 Standard Fee",
        "invoice": false,
        "descriptionId": 1,
        "descriptionType": "USCIS"
    },
    {
        "amount": "4000",
        "description": "Pub. L. 114-113",
        "invoice": false,
        "descriptionId": 4,
        "descriptionType": "USCIS"
    },
    {
        "amount": "370",
        "description": "H4 (I-539) Filing Fee",
        "invoice": false,
        "descriptionId": 6,
        "descriptionType": "USCIS"
    },
    {
        "amount": "410",
        "description": "H4 EAD (I-765) Filing Fee",
        "invoice": false,
        "descriptionId": 7,
        "descriptionType": "USCIS"
    },
    {
        "amount": "",
        "description": "Legal Fee",
        "invoice": false,
        "descriptionId": 8,
        "descriptionType": "Internal"
    },
    {
        "amount": "",
        "description": "Shipping and Handling",
        "invoice": false,
        "descriptionId": 9,
        "descriptionType": "Internal"
    },
{
        "amount": "460",
        "description": "I-129 Standard Fee",
        "invoice": false,
        "descriptionId": 1,
        "descriptionType": "USCIS"
    },
    {
        "amount": "4000",
        "description": "Pub. L. 114-113",
        "invoice": false,
        "descriptionId": 4,
        "descriptionType": "USCIS"
    },
    {
        "amount": "370",
        "description": "H4 (I-539) Filing Fee",
        "invoice": false,
        "descriptionId": 6,
        "descriptionType": "USCIS"
    },
    {
        "amount": "410",
        "description": "H4 EAD (I-765) Filing Fee",
        "invoice": false,
        "descriptionId": 7,
        "descriptionType": "USCIS"
    },
    {
        "amount": "",
        "description": "Legal Fee",
        "invoice": false,
        "descriptionId": 8,
        "descriptionType": "Internal"
    },
    {
        "amount": "",
        "description": "Shipping and Handling",
        "invoice": false,
        "descriptionId": 9,
        "descriptionType": "Internal"
    }
        ],
        feeData:[],
        items: ['list1', 'list2', 'list3', 'list4'],
        activeTab: null
    }),
    watch: {
      searchtxt: function (value) {
        let self =this;
        this.page = 1;
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          self.getList(true);
        }, 900)
        
      },
    },
    methods: {
        updateFeeDate(){
            this.feeData = _.cloneDeep(this.feeData)
        },
        setActive(index) {
            let self = this;
            let data = index;
            this.$validator.validateAll("filingFeesform").then((result) => {
                if(result){
                    self.checkLoading = true;
                    setTimeout(()=>{
                        _.forEach(self.feeData, (dItem)=>{
                            if(dItem && dItem['id'] == data['id'] && dItem['details'] && dItem['details'].length>0){
                                _.forEach(dItem['details'], (cItem)=>{
                                    cItem['isEdit'] = false; 
                                    cItem['editVal'] = cItem['name'];
                                })
                            }
                        });
                        self.feeData = _.cloneDeep(self.feeData)
                        self.activeTab = data;
                        self.checkLoading = false;
                    },100)
                }
            })
            
            // this.activeTab = data;
            // this.checkLoading = false;
        },
        checkFilingNames(){
            let changedTypeWithNames = []; 
            let codeObj = {
                code:'',
                name:''
            }
            _.forEach(this.feeData, (changedItem)=>{
                if(changedItem && changedItem['details'] && changedItem['details'].length>0){
                    _.forEach(changedItem['details'], (cItem)=>{
                        if(cItem && cItem['code']){
                            _.forEach(this.masterFeeData, (masterItem)=>{
                                if(masterItem && masterItem['details'] && masterItem['details'].length>0){
                                    _.forEach(masterItem['details'], (mItem)=>{
                                        if((mItem['code'] === cItem['code']) && (mItem.name !== cItem.name)){
                                            codeObj['code'] = cItem['code'];
                                            codeObj['name'] = cItem['name'];
                                            let findObj = _.find(changedTypeWithNames, {'code':cItem['code']});
                                            if(!findObj){
                                                changedTypeWithNames.push(codeObj);
                                            }
                                            codeObj = { code:'',  name:''}
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
            console.log(JSON.stringify(changedTypeWithNames))
        },
        updateFeeName(val, mainInd){
            let data = val;
            if(data['defType']){
                let filingData = _.forEach(this.feeData, (item)=>{
                    if(item && item['details'] && item['details'].length>0){
                        _.map(item['details'], (it)=>{
                            if(it['defType'] && (it['code'] == data['code']) ){ //&& it['defType'] 
                                it['name'] = data['name'];
                                it['editVal'] = data['name'];
                                it['isEdit'] = false;
                            }
                        })
                    }
                })
                this.feeData = _.cloneDeep(filingData)
            }
        },
        updateFilingFee(filingObj, action = false){
            let data = filingObj;
            let updateAction = action
            let filingData = _.forEach(this.feeData, (item)=>{
                if(item['_id'] == data['_id']){
                    item['isEdit'] = !item['isEdit']
                    if(item['details'] && item['details'].length>0){
                        _.map(item['details'], (it)=>{
                            it['isAlreadyExisted'] = updateAction;
                        })
                    }
                }
            })
            this.feeData = _.cloneDeep(filingData)
        },
        addItem(index){
            let objIds = _.map(this.feeData[index]['details'], 'id')
            let maxId = objIds.length>0?_.max(objIds):0;
            let time = new Date().getTime();
            // console.log(this.feeData[index]['details'])

            let itemObj={
                        "currency": "$",                        
                        "name": "",
                        "amount": 0,
                        'isEdit':true,
                        "type": "other",
                        'editVal':'',
                        // "status":true,
                        "tenantId": this.checkProperty(this.getUserData, "tenantDetails" , "_id"),
                        'id':time,
                        'allowMultiple':false,
            }
                this.feeData[index]['details'].push(itemObj)
        },

        removeItem(index, inde){
            this.feeData[index]['details'].splice(inde,1)
                // this.feeData[index]['details'][inde]['status']=false
                // this.feeData = _.cloneDeep(this.feeData) 
        },   
        manageInvoice(){
            this.$validator.validateAll("filingFeesform").then((result) => {
                if(result){  
                    let payLoad={
                        petitionType:this.checkProperty(this.selectedCaseType, 'id'),
                        tenantId: this.checkProperty(this.getUserData, "tenantDetails" , "_id"),
                        invoiceDate:this.invoiceDate,
                    };

                    let data = _.cloneDeep(this.feeData)
                    _.forEach(data, (item) => {
                         _.forEach(item.details, (detail) => {
                            if(_.has(detail, 'isAlreadyExisted')){
                                delete detail.isAlreadyExisted
                            }
                            if(_.has(detail, 'editVal')){
                                delete detail.editVal
                            }
                            if(_.has(detail, 'isEdit')){ 
                                delete detail.isEdit
                            }
                        });
                    });
                    let changeItems = []; 
                    let codeObj = {
                        code:'',
                        name:''
                    }
                    _.forEach(this.feeData, (changedItem)=>{
                        if(changedItem && changedItem['details'] && changedItem['details'].length>0){
                            _.forEach(changedItem['details'], (cItem)=>{
                                if(cItem && cItem['code']){
                                    _.forEach(this.masterFeeData, (masterItem)=>{
                                        if(masterItem && masterItem['details'] && masterItem['details'].length>0){
                                            _.forEach(masterItem['details'], (mItem)=>{
                                                if((mItem['code'] === cItem['code']) && (mItem.name !== cItem.name)){
                                                    codeObj['code'] = cItem['code'];
                                                    codeObj['name'] = cItem['name'];
                                                    let findObj = _.find(changeItems, {'code':cItem['code']});
                                                    if(!findObj){
                                                        changeItems.push(codeObj);
                                                    }
                                                    codeObj = { code:'',  name:''}
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                    // payLoad['items'] = this.feeData;
                    payLoad['items']= data;
                    payLoad['changeItems'] = changeItems;
                    let path='/invoices/save-case-type-filing-fee-categories';
                    this.$store.dispatch('commonAction', {"data":payLoad ,"path":path}).then((response)=>{
                        if(response && response.message){
                            this.showToster({ message: response.message, isError: false });
                        }
                        this.getFillingContent();
                    }).catch((error)=>{
                        if(error){
                            this.showToster({message:error,isError:true}); 
                        }
                        // console.log(error)
                    })
                }
            })
        },
        openConfirmation(){
            this.showConfirmPopup = true;
            this.invoiceDate = null;
        },
        getVisaTypes(callFromMount=false) {
            let item = {
                matcher: {
                "searchString": '',
                //   getWorkFlowConfig: true
                },
                page: this.page,
                perpage: this.perpage,
                category: "petition_types",
                "sorting": {
                "path": "name",
                "order": 1
                }
            };
            this.$store.dispatch("getMasterData", item)
            .then(response => {
                if(response && response.list){
                    this.visaTypes = response.list;
                    if(callFromMount){
                        this.selectedCaseType = this.visaTypes[0]
                        this.getFillingContent()
                    }
                    this.getSubtypes();
                }
            });
        },
        getSubtypes(){
            if (this.selectedCaseType && _.has(this.selectedCaseType, "id")) {
        let item = {
          matcher: {
            getAllSubTypes: false,
            searchString: '',
            petitionType: parseInt(this.selectedCaseType['id']),
            getWorkFlowConfig: false,
          },
          page: 1,
          perpage: 1000,
          category: "petition_sub_types",
          "sorting": {
            "path": "name",
            "order": 1
          }
        };

        this.$store.dispatch("getMasterData", item).then((response) => {
          this.all_subtypes = response.list;
          if(this.checkProperty(this.all_subtypes, 'length')>0){
            this.setActive(this.all_subtypes[0])
          }


        });
      }
        },
        saveInvoice(){
            //this.checkFilingNames()
             this.manageInvoice();
            //   this.openConfirmation()
        },
        getFillingContent(){
            let payLoad = {
                petitionType:this.checkProperty(this.selectedCaseType, 'id')
            }
            let path = '/invoices/get-case-type-filing-fee-categories';
            this.feeData =[];
            this.masterFeeData = [];
            this.isListloading= true;
            this.updateLoading(true);
            this.$store.dispatch('commonAction', {"data":payLoad ,"path":path}).then((response)=>{
                this.isListloading= false;
                if(_.has(response, 'alreadyExisted')){
                    this.alreadyExisted = response['alreadyExisted']
                }
                if(response && response['items']){
                    this.feeData = response['items'];
                    _.forEach(this.feeData, (item) => {
                        // item['isEdit'] = true 
                         _.forEach(item.details, (detail) => {
                            detail.isAlreadyExisted = true;
                            detail.isEdit = false;
                            detail.editVal = detail.name;
                            if(!_.has(detail, 'allowMultiple')){
                                detail.allowMultiple = false;
                            }
                        });
                    });  
                    this.masterFeeData = _.cloneDeep(this.feeData)
                };
                this.getSubtypes();
                this.updateLoading(false);
                setTimeout(()=>{
                    this.updateLoading(false);
                })
            }).catch((error)=>{
                this.updateLoading(false);
                this.isListloading= false;
                // console.log(error)
            })
        }
    },
    mounted() {
        this.getVisaTypes(true);
    },
  };
  </script>
  